import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import nodata from "../../Img/no-data.svg";
import {
  useTheme,
  useMediaQuery,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useEffect } from "react";
import { useContext } from "react";
import consts from "../../constant";
import usercalls from "../../Axios";
import Context from "../../Context";
import { useLocation, useParams } from "react-router-dom";
import { Capitalize } from "../../Helpers/StringFunctions";
import { getTimeFormat } from '../../Helpers/DateAndTime'

export default function Tradehistorytab() {
  const theme = useTheme();
  const { id } = useParams();
  const loaction = useLocation();
  const path = usercalls();
  const placeRoute = loaction.pathname?.split("/")[1];
  const mobilemd = useMediaQuery(theme.breakpoints.up("md"));
  const { activeTabId, history } = useContext(Context);
  const [orderHistory, setOrderHistory] = useState([]);
  const [historyDropdown, setHistoryDropDown] = useState("spot");
  const [current_activeTab, setcurrent_ActiveTab] = useState("Last 7 D");

  const handleHistoryDropdownChange = (e) => {
    setHistoryDropDown(e.target.value);
  };

  const scrollRef = React.useRef(null);

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const getHistory = async () => {
    try {
      setOrderHistory([]);
      const url =
        placeRoute === "trade"
          ? `${consts.BackendUrl}/ownTrade/orderhistory?page=1&limit=5`
          : `${consts.BackendUrl}/ownTrade/futureTradeHistory?page=1&limit=5`;
      const payload = {
        pair: id,
        type: placeRoute == "trade" ? historyDropdown : "futures",
        startDate:
          current_activeTab === "Last 30 D"
            ? new Date(
              new Date().getTime() - 30 * 24 * 60 * 60 * 1000
            ).toISOString()
            : new Date(
              new Date().getTime() - 7 * 24 * 60 * 60 * 1000
            ).toISOString(),
        endDate: new Date().toISOString(),
        history: "trade"
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setOrderHistory(result?.result?.docs);
      }
    } catch (error) {
      console.log("🚀 ~ getHistory ~ error:", error);
    }
  };

  useEffect(() => {
    if ((id && activeTabId === "tab5") || placeRoute === "future") {
      getHistory();
    }
    // console.log(activeTabId);
  }, [id, current_activeTab, historyDropdown, activeTabId, placeRoute, history]);

  const tableData = [
    // {
    //   spotPairs: 'BTC/USD',
    //   orderType: 'Limit',
    //   direction: 'Buy',
    //   filledValue: '1000 USD',
    //   filledPrice: '$20000',
    //   filledQty: '0.5 BTC',
    //   tradingFee: '0.1%',
    //   filledTime: '2025-01-20 10:00:00',
    //   transactionId: 'TX12345',
    //   orderId: 'ORD12345',
    // },
    // {
    //   spotPairs: 'ETH/USD',
    //   orderType: 'Market',
    //   direction: 'Sell',
    //   filledValue: '500 USD',
    //   filledPrice: '$2500',
    //   filledQty: '2 ETH',
    //   tradingFee: '0.15%',
    //   filledTime: '2025-01-19 14:30:00',
    //   transactionId: 'TX12346',
    //   orderId: 'ORD12346',
    // },
    // {
    //   spotPairs: 'XRP/USD',
    //   orderType: 'Stop',
    //   direction: 'Buy',
    //   filledValue: '300 USD',
    //   filledPrice: '$2',
    //   filledQty: '1500 XRP',
    //   tradingFee: '0.12%',
    //   filledTime: '2025-01-20 12:00:00',
    //   transactionId: 'TX12347',
    //   orderId: 'ORD12347',
    // },
  ];

  return (
    <>
      <div className="history_inner_tab">
        <div className="display-2">
          <div className="h_tabs gap-15">
            <button
              style={{ background: "transparent" }}
              className={`history_button cursor ${current_activeTab === "Last 7 D" ? "active" : ""
                }`}
              onClick={() => setcurrent_ActiveTab("Last 7 D")}
            >
              Last 7 D
            </button>
            <button
              style={{ background: "transparent" }}
              className={`history_button cursor ${current_activeTab === "Last 30 D" ? "active" : ""
                }`}
              onClick={() => setcurrent_ActiveTab("Last 30 D")}
            >
              Last 30 D
            </button>
          </div>
          {placeRoute === "trade" && (
            <FormControl
              className="spot-drop-down"
              sx={{
                minWidth: "80px",
              }}
            >
              <Select
                label="Order Type"
                value={historyDropdown}
                onChange={handleHistoryDropdownChange}
                sx={{
                  "& .MuiInputBase-formControl": {
                    border: "0px",
                  },
                  "& fieldset": {
                    border: "none !important",
                  },
                  svg: {
                    fill: "#fff !important",
                    right: "0px !important",
                  },
                }}
              >
                <MenuItem value="spot">Spot</MenuItem>
                <MenuItem value="margin">Margin</MenuItem>
              </Select>
            </FormControl>
          )}
          {/* <button
              style={{background:"transparent"}}
              className={`history_button ${current_activeTab === "Last 180 D" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab("Last 180 D")}
            >
              Last 180 D
            </button> */}
        </div>
        {current_activeTab === "Last 7 D" && (
          <div className="table_height">
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell align="left" className="fixed-left">
                      Order Time
                    </TableCell>
                    <TableCell align="center" className="fixed-left">
                      Pairs
                    </TableCell>
                    <TableCell align="center">Order Type</TableCell>
                    <TableCell align="center">Side</TableCell>
                    <TableCell align="center">Filled Price</TableCell>
                    <TableCell align="center">Filled Quantity</TableCell>
                    <TableCell align="center">Filled Volume</TableCell>
                    <TableCell align="center">
                      <div className="transa-tradingfee-item">
                        <div className="inline-block">
                          <span className="transa-tradingfee-item-underline">
                            Trading Fee
                          </span>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderHistory?.length > 0 ? (
                    orderHistory?.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left" className="fixed-left">
                          {getTimeFormat(row?.createdAt)}
                          {/* {row?.createdAt} */}
                        </TableCell>
                        <TableCell align="center" className="fixed-left">
                          {row?.pair}
                        </TableCell>
                        <TableCell align="center">
                          {Capitalize(row.order_type)}
                        </TableCell>

                        {placeRoute == "future" ? (
                          // <TableCell>{row?.positionSide == "LONG" && row?.trade_type == "BUY" ? "Open Long" : row?.positionSide == "SHORT" && row?.trade_type == "BUY" ? "Close Long" : row?.positionSide == "LONG" && row?.trade_type == "SELL" ? "Close Short" : "Open Short"}</TableCell>
                          <>
                            {row?.positionSide == "long" &&
                              row?.trade_type == "sell" && (
                                <TableCell align="center">Close Long</TableCell>
                              )}

                            {row?.positionSide == "short" &&
                              row?.trade_type == "buy" && ( // correct
                                <TableCell align="center">
                                  Close Short
                                </TableCell>
                              )}

                            {row?.positionSide == "long" &&
                              row?.trade_type == "buy" && (
                                <TableCell align="center">Open Long</TableCell>
                              )}

                            {row?.positionSide == "short" &&
                              row?.trade_type == "sell" && (
                                <TableCell align="center">Open Short</TableCell>
                              )}
                          </>
                        ) : (
                          <TableCell align="center">
                            {Capitalize(row.trade_type)}
                          </TableCell>
                        )}
                        <TableCell align="center">
                          {row?.avg_price == 0 ? "-" : row?.avg_price}
                          {" "}
                          {
                            (placeRoute == "trade" || placeRoute == "future") &&
                            row?.pair?.split('_')[1]
                          }
                        </TableCell>
                        <TableCell align="center">{Number(row?.originalvolume)} {(placeRoute == "trade" || placeRoute == "future") && row?.pair?.split('_')[0]} </TableCell>
                        <TableCell align="center">{Number(row?.filledValue)}
                          {" "}
                          {
                            (placeRoute == "trade" || placeRoute == "future") &&
                            row?.pair?.split('_')[1]
                          }
                        </TableCell>
                        <TableCell align="center">
                          {(Number(row?.fees) + Number(row?.own_fee))?.toFixed(8)}{" "}
                          {(placeRoute === "trade" || placeRoute === "future") ? row.fee_taken_Asset : ""}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <img
                          src={nodata}
                          alt="No Data"
                          style={{ maxWidth: "100px" }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        {current_activeTab === "Last 30 D" && (
          <div className="table_height">
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell align="left" className="fixed-left">
                      Order Time
                    </TableCell>
                    <TableCell align="center" className="fixed-left">
                      Pairs
                    </TableCell>
                    <TableCell align="center">Order Type</TableCell>
                    <TableCell align="center">Side</TableCell>
                    <TableCell align="center">Filled Price</TableCell>
                    <TableCell align="center">Filled Quantity</TableCell>
                    <TableCell align="center">Filled Volume</TableCell>
                    <TableCell align="center">
                      <div className="transa-tradingfee-item">
                        <div className="inline-block">
                          <span className="transa-tradingfee-item-underline">
                            Trading Fee
                          </span>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderHistory.length > 0 ? (
                    orderHistory.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="left" className="fixed-left">
                          {getTimeFormat(row?.createdAt)}
                          {/* {row?.createdAt} */}
                        </TableCell>
                        <TableCell align="center" className="fixed-left">
                          {row?.pair}
                        </TableCell>
                        <TableCell align="center">
                          {Capitalize(row.order_type)}
                        </TableCell>
                        {placeRoute == "future" ? (
                          // <TableCell>{row?.positionSide == "LONG" && row?.trade_type == "BUY" ? "Open Long" : row?.positionSide == "SHORT" && row?.trade_type == "BUY" ? "Close Long" : row?.positionSide == "LONG" && row?.trade_type == "SELL" ? "Close Short" : "Open Short"}</TableCell>
                          <>
                            {row?.positionSide == "long" &&
                              row?.trade_type == "sell" && (
                                <TableCell align="center">Close Long</TableCell>
                              )}

                            {row?.positionSide == "short" &&
                              row?.trade_type == "buy" && ( // correct
                                <TableCell align="center">
                                  Close Short
                                </TableCell>
                              )}

                            {row?.positionSide == "long" &&
                              row?.trade_type == "buy" && (
                                <TableCell align="center">Open Long</TableCell>
                              )}

                            {row?.positionSide == "short" &&
                              row?.trade_type == "sell" && (
                                <TableCell align="center">Open Short</TableCell>
                              )}
                          </>
                        ) : (
                          <TableCell align="center">
                            {Capitalize(row.trade_type)}
                          </TableCell>
                        )}

                        <TableCell align="center">
                          {row?.avg_price == 0 ? "-" : row?.avg_price}
                          {" "}
                          {
                            (placeRoute == "trade" || placeRoute == "future") &&
                            row?.pair?.split('_')[1]
                          }
                        </TableCell>
                        <TableCell align="center">{Number(row?.originalvolume)} {(placeRoute == "trade" || placeRoute == "future") && row?.pair?.split('_')[0]} </TableCell>
                        <TableCell align="center">
                          {row?.filledValue}
                          {" "}
                          {
                            (placeRoute == "trade" || placeRoute == "future") &&
                            row?.pair?.split('_')[1]
                          }
                        </TableCell>
                        <TableCell align="center">
                          {(Number(row?.fees) + Number(row?.own_fee))?.toFixed(8)}{" "}
                          {(placeRoute === "trade" || placeRoute === "future") ? row.fee_taken_Asset : ""}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <img
                          src={nodata}
                          alt="No Data"
                          style={{ maxWidth: "100px" }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        {/* {current_activeTab === "Last 180 D" &&
          <div className="table_height">
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell className="fixed-left">Spot Pairs</TableCell>
                    <TableCell>Order Type</TableCell>
                    <TableCell>Direction</TableCell>
                    <TableCell>Filled Value</TableCell>
                    <TableCell>Filled Price</TableCell>
                    <TableCell>Filled Qty</TableCell>
                    <TableCell>
                      <div className="transa-tradingfee-item">
                        <div className="inline-block">
                          <span className="transa-tradingfee-item-underline">Trading Fee</span>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>Filled Time</TableCell>
                    <TableCell>Transaction ID</TableCell>
                    <TableCell>Order ID</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.length > 0 ? (
                    tableData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell className="fixed-left">{row.spotPairs}</TableCell>
                        <TableCell>{row.orderType}</TableCell>
                        <TableCell>{row.direction}</TableCell>
                        <TableCell>{row.filledValue}</TableCell>
                        <TableCell>{row.filledPrice}</TableCell>
                        <TableCell>{row.filledQty}</TableCell>
                        <TableCell>{row.tradingFee}</TableCell>
                        <TableCell>{row.filledTime}</TableCell>
                        <TableCell>{row.transactionId}</TableCell>
                        <TableCell>{row.orderId}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="left">
                        <img src={nodata} alt="No Data" style={{ maxWidth: "100px" }} />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>} */}
      </div>
    </>
  );
}
